module.exports = __webpack_public_path__ + "img/2437.64c23f02.jpg";